/** @format */

import { AssetNote } from '@/ducks/room/declarations';
import { useAppTranslation } from '@/i18n/declarations';
import { TLocale } from '@/utils/gatsby/types';
import React, { FunctionComponent, useMemo } from 'react';
import { AssetNotesContainer, ElementContainer } from './RoomAssetNotes.style';

const RoomAssetNotes: FunctionComponent<RoomAssetNotesProps> = ({ assetNotes }) => {
  const { intl } = useAppTranslation();

  const sortedNotes = useMemo(() => {
    if (assetNotes.length === 0) return [];

    return assetNotes.sort((a: AssetNote, b: AssetNote) => sortTypes([a.type, b.type]));
  }, [assetNotes]);

  return (
    <AssetNotesContainer>
      {sortedNotes.map((note, index) => (
        <ElementContainer type={note.type}>
          <p key={index}>{note[intl.locale as TLocale]}</p>
        </ElementContainer>
      ))}
    </AssetNotesContainer>
  );
};

export default RoomAssetNotes;

const sortTypes = (types: string[]): number => {
  const order = ['positive', 'info', 'warning'];
  return order.indexOf(types[0]) - order.indexOf(types[1]);
};

interface RoomAssetNotesProps {
  assetNotes: AssetNote[];
}
